export var WM_MESSAGE_TYPE;

(function (WM_MESSAGE_TYPE) {
  WM_MESSAGE_TYPE["CAMPAIGN"] = "CAMPAIGN";
  WM_MESSAGE_TYPE["MESSAGE_SHOWN"] = "MESSAGE_SHOWN";
  WM_MESSAGE_TYPE["IMAGE_CONVERSION_FAILED"] = "IMAGE_CONVERSION_FAILED";
  WM_MESSAGE_TYPE["INFORM_SDP"] = "INFORM_SDP";
})(WM_MESSAGE_TYPE || (WM_MESSAGE_TYPE = {}));

export var EVENTS;

(function (EVENTS) {
  EVENTS["MY_ACCOUNT_DROPDOWN_OPEN"] = "wh.myAccount.command.dropdown.open";
})(EVENTS || (EVENTS = {}));

export var STANDALONE_ACTION;

(function (STANDALONE_ACTION) {
  STANDALONE_ACTION["CLOSE"] = "close";
  STANDALONE_ACTION["OPEN_URL"] = "openURL";
})(STANDALONE_ACTION || (STANDALONE_ACTION = {}));

export var Environment;

(function (Environment) {
  Environment["PROD"] = "prod";
  Environment["PP1"] = "pp1";
  Environment["PP2"] = "pp2";
  Environment["PP3"] = "pp3";
})(Environment || (Environment = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy50cyJdLCJuYW1lcyI6WyJXTV9NRVNTQUdFX1RZUEUiLCJFVkVOVFMiLCJTVEFOREFMT05FX0FDVElPTiIsIkVudmlyb25tZW50Il0sIm1hcHBpbmdzIjoiQUFBQSxXQUFZQSxlQUFaOztXQUFZQSxlO0FBQUFBLEVBQUFBLGU7QUFBQUEsRUFBQUEsZTtBQUFBQSxFQUFBQSxlO0FBQUFBLEVBQUFBLGU7R0FBQUEsZSxLQUFBQSxlOztBQU9aLFdBQVlDLE1BQVo7O1dBQVlBLE07QUFBQUEsRUFBQUEsTTtHQUFBQSxNLEtBQUFBLE07O0FBSVosV0FBWUMsaUJBQVo7O1dBQVlBLGlCO0FBQUFBLEVBQUFBLGlCO0FBQUFBLEVBQUFBLGlCO0dBQUFBLGlCLEtBQUFBLGlCOztBQUtaLFdBQVlDLFdBQVo7O1dBQVlBLFc7QUFBQUEsRUFBQUEsVztBQUFBQSxFQUFBQSxXO0FBQUFBLEVBQUFBLFc7QUFBQUEsRUFBQUEsVztHQUFBQSxXLEtBQUFBLFciLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBXTV9NRVNTQUdFX1RZUEUge1xuICBDQU1QQUlHTiA9ICdDQU1QQUlHTicsXG4gIE1FU1NBR0VfU0hPV04gPSAnTUVTU0FHRV9TSE9XTicsXG4gIElNQUdFX0NPTlZFUlNJT05fRkFJTEVEID0gJ0lNQUdFX0NPTlZFUlNJT05fRkFJTEVEJyxcbiAgSU5GT1JNX1NEUCA9ICdJTkZPUk1fU0RQJyxcbn1cblxuZXhwb3J0IGVudW0gRVZFTlRTIHtcbiAgTVlfQUNDT1VOVF9EUk9QRE9XTl9PUEVOID0gJ3doLm15QWNjb3VudC5jb21tYW5kLmRyb3Bkb3duLm9wZW4nLFxufVxuXG5leHBvcnQgZW51bSBTVEFOREFMT05FX0FDVElPTiB7XG4gIENMT1NFID0gJ2Nsb3NlJyxcbiAgT1BFTl9VUkwgPSAnb3BlblVSTCcsXG59XG5cbmV4cG9ydCBlbnVtIEVudmlyb25tZW50IHtcbiAgUFJPRCA9ICdwcm9kJyxcbiAgUFAxID0gJ3BwMScsXG4gIFBQMiA9ICdwcDInLFxuICBQUDMgPSAncHAzJyxcbn1cbiJdfQ==